import React from "react"

import {
  HeroSection,
  AboutSection,
  ServicesSection,
  FeaturedServicesSection,
  ContactSection,
  CTASection,
  PackagesSection,
  EventsSection,
  CredentialsSection,
  CTABannerSection,
  KeywordsSection,
  HeaderSection,
  FooterSection,
  FAQSection,
  ReviewsSection,
  GallerySection,
  QuoteSection,
  SubHeroSection,
  GenericSection
} from "./components"

const SectionRenderer = ({
  section,
  practice,
  theme,
  highlightedField,
  pageSlug = null,
  viewMode = "",
  deviceType = "desktop"
}) => {
  const commonProps = { section, practice, theme, highlightedField, viewMode, deviceType }

  // Create anchor ID for the section - include type and order for better identification
  const sectionAnchorId =
    section.layout === "events" ? "events-section-full" : `section-${section.layout}-${section.id}`

  // Wrap the section with an anchor element for scrolling
  const renderSectionWithAnchor = (sectionComponent) => (
    <div id={sectionAnchorId} className="scroll-mt-20">
      {sectionComponent}
    </div>
  )

  switch (section.layout) {
    case "hero": {
      const isHome = pageSlug === "home"
      return renderSectionWithAnchor(isHome ? <HeroSection {...commonProps} /> : <SubHeroSection {...commonProps} />)
    }

    case "sub_hero":
      return renderSectionWithAnchor(<SubHeroSection {...commonProps} />)

    case "about":
      return renderSectionWithAnchor(<AboutSection {...commonProps} />)

    case "services":
      return renderSectionWithAnchor(<ServicesSection {...commonProps} pageSlug={pageSlug} />)

    case "featured_services":
      return renderSectionWithAnchor(<FeaturedServicesSection {...commonProps} pageSlug={pageSlug} />)

    case "contact":
      return renderSectionWithAnchor(<ContactSection {...commonProps} />)

    case "cta_content":
      return renderSectionWithAnchor(<CTASection {...commonProps} />)

    case "packages":
      return renderSectionWithAnchor(<PackagesSection {...commonProps} pageSlug={pageSlug} />)

    case "events":
      return renderSectionWithAnchor(<EventsSection {...commonProps} pageSlug={pageSlug} />)

    case "credentials":
      return renderSectionWithAnchor(<CredentialsSection {...commonProps} />)

    case "cta_banner":
      return renderSectionWithAnchor(<CTABannerSection {...commonProps} />)

    case "keywords":
      return renderSectionWithAnchor(<KeywordsSection {...commonProps} />)

    case "header":
      return renderSectionWithAnchor(<HeaderSection {...commonProps} />)

    case "footer":
      return renderSectionWithAnchor(<FooterSection {...commonProps} />)

    case "faq":
      return renderSectionWithAnchor(<FAQSection {...commonProps} />)

    case "quote":
      return renderSectionWithAnchor(<QuoteSection {...commonProps} />)

    case "reviews":
      return renderSectionWithAnchor(<ReviewsSection {...commonProps} pageSlug={pageSlug} />)

    case "gallery":
      return renderSectionWithAnchor(<GallerySection {...commonProps} />)

    // Sections that still use the generic renderer
    default:
      return renderSectionWithAnchor(<GenericSection {...commonProps} />)
  }
}

export default SectionRenderer
